import React from 'react';
import ProgressBar from "@ramonak/react-progress-bar";

export default function UiTableProgressBar(props) {

    const getRandomColor = () => {
        const colorList = [
            "#F2E205",
            "#FE8E38",
            "#FD7D56",
            "#05F2DB",
            "#FF4171",
            "#0B42FF",
            "#35F29A",
        ];
     
        return colorList[Math.floor(Math.random() * colorList.length)];
    };

    return (
        <>
            <ProgressBar
                labelAlignment="left"
                bgColor={getRandomColor()}
                labelColor="#000"
                labelSize="11px"
                borderRadius="0px"
                labelClassName="sba-grid-progression"
                completed={Math.round(props.completed)} />

        </>
    )
}
